import React from "react";

import ApprovalConfirmModal, {
  ApprovalConfirmVariant,
} from "../utils/ApprovalConfirmModal";

type Props = {
  visible: boolean;
  title?: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  destructive?: boolean;
  loading?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ConfirmDialog({
  visible,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Yes",
  cancelText = "Cancel",
  destructive = false,
  loading = false,
  onCancel,
  onConfirm,
}: Props) {
  const variant: ApprovalConfirmVariant = destructive ? "reject" : "warning";

  return (
    <ApprovalConfirmModal
      visible={visible}
      title={title}
      message={message}
      confirmLabel={confirmText}
      cancelLabel={cancelText}
      variant={variant}
      loading={loading}
      onClose={onCancel}
      onConfirm={onConfirm}
    />
  );
}
